import React, { useEffect, useState } from 'react';
import './ServiceDescription.scss';
import { useSelector } from 'react-redux';
import { ClickOutside } from '../../../components/ClickOutside';
import {
    getSavedCitizenship,
    saveCitizenship,
} from '../../../utils/citizenshipStorage';
import { getSelectedService } from '../../store/selectors';

const styles = require('b_')
    .with('service-description');

const SHORT_TEXT_LENGTH = 150;
const CITIZENSHIP_OPTIONS = [
    { id: 'belarus', name: 'для граждан РБ' },
    { id: 'foreign', name: 'для иностранных граждан' },
];
const CITIZENSHIP_IDS = CITIZENSHIP_OPTIONS.map(({ id }) => id);

const formatPrice = (price) => {
    const normalizedPrice = Number(price);

    return Number.isFinite(normalizedPrice)
        ? normalizedPrice.toFixed(2).replace('.', ',')
        : price;
};

export const ServiceDescription = ({ selectedService: _selectedService }) => {
    const [ partialText, setPartialText ] = useState(true);
    const [ citizenship, setCitizenship ] = useState(() => getSavedCitizenship(CITIZENSHIP_IDS));
    const [ citizenshipMenuOpen, setCitizenshipMenuOpen ] = useState(false);
    const { selectedServices } = useSelector(getSelectedService);

    useEffect(() => {
        setPartialText(true);
    }, [ selectedServices, _selectedService ]);

    const handleCitizenshipSelect = (id) => {
        setCitizenship(id);
        setCitizenshipMenuOpen(false);
        saveCitizenship(id);
    };

    const description = selectedServices?.description?.trim() || _selectedService?.description?.trim();
    const belarusPrice = selectedServices?.price ?? _selectedService?.price;
    const internationalPrice = selectedServices?.internationalPrice ?? _selectedService?.internationalPrice;
    const hasInternationalPrice = internationalPrice != null;
    const price = citizenship === 'foreign' && hasInternationalPrice
        ? internationalPrice
        : belarusPrice;
    const selectedCitizenship = CITIZENSHIP_OPTIONS.find(({ id }) => id === citizenship);
    return (description || price != null) ? (
        <div className={styles()}>
            {price != null && (
                <>
                    <div className={styles('price-header')}>
                        <div className={styles('price-label')}>
                            Стоимость*
                        </div>
                        {hasInternationalPrice && (
                            <ClickOutside onClick={() => setCitizenshipMenuOpen(false)} open={citizenshipMenuOpen}>
                                <div className={styles('citizenship')}>
                                    <button
                                        type="button"
                                        className={styles('citizenship-toggle')}
                                        onClick={() => setCitizenshipMenuOpen(prev => !prev)}>
                                        {selectedCitizenship?.name}
                                        <i className={styles('arrow', citizenshipMenuOpen ? { up: true } : { down: true })}></i>
                                    </button>
                                    {citizenshipMenuOpen && (
                                        <ul className={styles('citizenship-menu')}>
                                            {CITIZENSHIP_OPTIONS.map(({ id, name }) => (
                                                // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
                                                <li
                                                    key={id}
                                                    className={styles('citizenship-option', { selected: id === citizenship })}
                                                    onClick={() => handleCitizenshipSelect(id)}>
                                                    {name}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </ClickOutside>
                        )}
                    </div>
                    <div className={styles('price')}>
                        {formatPrice(price)} <span className="nbrb-icon currency-symbol">BYN</span>
                    </div>
                    <div className={styles('price-note')}>
                        * Расходные материалы и дополнительные услуги оплачиваются отдельно.
                    </div>
                </>
            )}
            {description ? (
                <>
                    <div className={styles('header')}>Описание</div>
                    <div className={styles('text')}>
                        <div className={styles('content', { partialText })}>
                            {partialText
                                ? `${description?.trim()
                                    .substring(0, SHORT_TEXT_LENGTH)}${
                                    description?.length > SHORT_TEXT_LENGTH ? '...' : ''
                                }`
                                : String(description)
                                    .trim()}
                        </div>
                        {description.length > SHORT_TEXT_LENGTH && (
                            // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                            <p className={styles('link')} onClick={() => setPartialText(prev => !prev)}>
                                Показать {partialText ? 'больше' : 'меньше'}
                                <i className={styles('arrow', partialText ? { down: true } : { up: true })}></i>
                            </p>
                        )}
                    </div>
                </>
            ) : null}
        </div>
    ) : null;
};
